import { Injectable } from '@angular/core';
import { AdditionalDataKeysRepository } from '../../../../core/repositories';
import {
  HttpClient,
  HttpErrorResponse,
  HttpParams,
} from '@angular/common/http';
import {
  AdditionalDataKey,
  BaseResponse,
} from '../../../../core/domain/models';
import { catchError, map, mergeMap, Observable, reduce } from 'rxjs';
import { AdditionalDataKeyApiUrls } from './additional-data-key-api-urls';
import { AdditionalDataKeyWebEntity } from './additional-data-key.web-entity';
import { AdditionalDataKeyWebRepositoryMapper } from './additional-data-key.web-repository-mapper';
import { injectEnvironment } from 'master-locations-library/master-locations-library/src/lib/core/environments/environment.token';

@Injectable()
export class AdditionalDataKeysWebRepository
  implements AdditionalDataKeysRepository
{
  mapper = new AdditionalDataKeyWebRepositoryMapper();
  environment = injectEnvironment();

  constructor(private httpClient: HttpClient) {}

  getAdditionalDataKeys(
    params: string | undefined
  ): Observable<AdditionalDataKey[]> {
    const queryParams = new HttpParams().set('searchText', params ?? '');
    return this.httpClient
      .get<BaseResponse<AdditionalDataKeyWebEntity[]>>(
        `${this.environment.url}${AdditionalDataKeyApiUrls.GetAdditionalDataKeys}`,
        { params: queryParams }
      )
      .pipe(
        mergeMap((response) => response.result),
        catchError((err: HttpErrorResponse) => {
          throw err;
        })
      )
      .pipe(
        reduce(
          (items: AdditionalDataKey[], item: AdditionalDataKey) => [
            ...items,
            item,
          ],
          []
        )
      );
  }

  getAdditionalDataKey(
    params: string | undefined
  ): Observable<AdditionalDataKey> {
    const queryParams = new HttpParams().set('keyName', params ?? '');
    return this.httpClient
      .get<BaseResponse<AdditionalDataKeyWebEntity[]>>(
        `${this.environment.url}${AdditionalDataKeyApiUrls.GetAdditionalDataKey}`,
        { params: queryParams }
      )
      .pipe(
        mergeMap((response) => response.result),
        catchError((err: HttpErrorResponse) => {
          throw err;
        })
      )
      .pipe(map(this.mapper.mapFrom));
  }
}
